import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge class names with Tailwind-aware conflict resolution (shadcn 约定). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
